import { QueryFunctionContext, useQuery } from '@tanstack/react-query'
import { getApiClient } from '../../../shared/types/api-client'
import { CommandAudit, CommandAuditType } from '../types/CommandAudit'

const SCOPE = 'commandAudits'
const LIST = 'list'

interface CommandAuditsFilter {
  functionAppName?: string
  functionName?: string
  userName?: string
  type?: CommandAuditType
  offset: number
  limit: number
}

const keysFactory = {
  list: (filters: CommandAuditsFilter) => [{ scope: SCOPE, entity: LIST, ...filters }] as const,
}

const getCommandAudits = async ({
  queryKey: [filters],
}: QueryFunctionContext<ReturnType<(typeof keysFactory)['list']>>) => {
  const apiClient = getApiClient()
  const response = await apiClient.post('CommandAudits', filters)
  return response.data as CommandAudit[]
}

export function useCommandAudits(filters: CommandAuditsFilter, enabled = true): [CommandAudit[], boolean] {
  const { isFetching, data } = useQuery({
    queryKey: [...keysFactory.list(filters)],
    queryFn: getCommandAudits,
    placeholderData: [],
    enabled,
  })
  return [data ?? [], isFetching]
}
